<template>
  <div class="pop">
    <van-image
      class="image"
      :src="cutoutPicture[0]"
      mode="widthFix"
    ></van-image>
    <div class="form1">
      <van-image
        class="image"
        :src="cutoutPicture[1]"
        mode="widthFix"
      ></van-image>
      <submitForm class="form" :btnImg="cutoutPicture[5]" />
    </div>
    <van-image
      class="image"
      :src="cutoutPicture[2]"
      mode="widthFix"
    ></van-image>
    <div class="form2">
      <van-image
        class="image"
        :src="cutoutPicture[3]"
        mode="widthFix"
      ></van-image>
      <submitForm class="form" :btnImg="cutoutPicture[5]" />
    </div>
    <van-image
      class="image"
      :src="cutoutPicture[4]"
      mode="widthFix"
    ></van-image>
  </div>
</template>
<script>
import submitForm from "./components/SubmitForm.vue";
import { commonactivityList } from "@/api";
export default {
  name: "WxLive",
  components: {
    submitForm,
  },
  data() {
    return {
      cutoutPicture: [
        "https://derucci-app-obs.iderucci.com/consumer-admin-derucci/20230612/MS0xLjE2ODY1Mzk3ODMzNjc=.jpg",
        "https://derucci-app-obs.iderucci.com/consumer-admin-derucci/20230612/MS0yLjE2ODY1Mzk3ODMyNTA=.jpg",
        "https://derucci-app-obs.iderucci.com/consumer-admin-derucci/20230612/MS0zLjE2ODY1Mzk3ODM0MDM=.jpg",
        "https://derucci-app-obs.iderucci.com/consumer-admin-derucci/20230612/MS00LjE2ODY1Mzk3ODMzMzI=.jpg",
        "https://derucci-app-obs.iderucci.com/consumer-admin-derucci/20230612/MS01LjE2ODY1Mzk3ODMzMDA=.jpg",
        "https://derucci-app-obs.iderucci.com/consumer-admin-derucci/20230612/YnRuLjE2ODY1NDA2MDU2MzE=.png",
      ],
      activityItem: {},
      formData: {},
    };
  },
  created() {
    const { serviceId, phoneNumber, province, city } = this.$route.query;
    this.formData = {
      phoneNumber,
      province,
      city,
    };
    this.getSplitList(serviceId);
  },
  methods: {
    getSplitList(serviceId) {
      commonactivityList({ serviceId, ascriptionModular: "10" }).then((res) => {
        this.activityItem = res.page?.list[0];
        if (this.activityItem?.cutoutPicture)
          this.cutoutPicture = this.activityItem.cutoutPicture.split(",");

        this.cutoutPicture[5] =
          "https://derucci-app-obs.iderucci.com/consumer-admin-derucci/20230612/YnRuLjE2ODY1NDA2MDU2MzE=.png";
      });
    },
  },
};
</script>
<style scoped lang="scss">
.pop {
  .image {
    display: block;
    width: 100%;
  }
  .form {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 2;
    padding: 0 20px;
    padding-top: 70px;
  }
  .form1 {
    position: relative;
  }
  .form2 {
    position: relative;
  }
}
</style>
